import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FilterState {
  payPeriod: string;
  site: string;
}

const initialState: FilterState = {
  payPeriod: 'Feb 10 - Feb 16',
  site: '1 Site Selected',
};

const EmpTimecardFilterSlice = createSlice({
  name: 'EmpTimecardFilter',
  initialState,
  reducers: {
    setPayPeriod(state, action: PayloadAction<string>) {
      state.payPeriod = action.payload;
    },
    setSite(state, action: PayloadAction<string>) {
      state.site = action.payload;
    },
    clearFilters(state) {
      state.payPeriod = 'Feb 10 - Feb 16';
      state.site = '1 Site Selected';
    },
  },
});

export const { setPayPeriod, setSite, clearFilters } = EmpTimecardFilterSlice.actions;
export default EmpTimecardFilterSlice.reducer;
